import * as React from "react";

const OnlineTestIllustration = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        id="freepik_stories-online-test"
        className="animated"
        version="1.1"
        width={"100%"}
        height={"25rem"}
        viewBox="0 0 450 450">
        <g id="freepik--background-complete--inject-62" className="animable">
            <path
                id="eln0p5i8uvwho"
                fill="#EBEBEB"
                d="M0 382.4h500v.25H0z"
                className="animable"
                transform-origin="250px 382.525px"
            ></path>
            <path
                id="el5509rgpbg94"
                fill="#EBEBEB"
                d="M416.78 398.49h33.12v.25h-33.12z"
                className="animable"
                transform-origin="433.34px 398.615px"
            ></path>
            <path
                id="el6hz5o36rgrg"
                fill="#EBEBEB"
                d="M322.53 401.21h8.69v.25h-8.69z"
                className="animable"
                transform-origin="326.875px 401.335px"
            ></path>
            <path
                id="elfiqbxh58bh7"
                fill="#EBEBEB"
                d="M396.59 389.21h19.19v.25h-19.19z"
                className="animable"
                transform-origin="406.185px 389.335px"
            ></path>
            <path
                id="el1ig5fnoz0pq"
                fill="#EBEBEB"
                d="M52.46 390.89h43.19v.25H52.46z"
                className="animable"
                transform-origin="74.055px 391.015px"
            ></path>
            <path
                id="elfxgj9gr9uni"
                fill="#EBEBEB"
                d="M104.56 390.89h6.33v.25h-6.33z"
                className="animable"
                transform-origin="107.725px 391.015px"
            ></path>
            <path
                id="el9djjoa6gnz"
                fill="#EBEBEB"
                d="M131.47 395.11h93.68v.25h-93.68z"
                className="animable"
                transform-origin="178.31px 395.235px"
            ></path>
            <path
                id="elfz3k7oopwnh"
                fill="#EBEBEB"
                d="M237 337.8H43.91a5.71 5.71 0 0 1-5.7-5.71V60.66a5.71 5.71 0 0 1 5.7-5.66H237a5.71 5.71 0 0 1 5.71 5.71v271.38a5.71 5.71 0 0 1-5.71 5.71M43.91 55.2a5.46 5.46 0 0 0-5.45 5.46v271.43a5.46 5.46 0 0 0 5.45 5.46H237a5.47 5.47 0 0 0 5.46-5.46V60.66A5.47 5.47 0 0 0 237 55.2Z"
                className="animable"
                transform-origin="140.46px 196.4px"
            ></path>
            <path
                id="el4y2naa2vc3y"
                fill="#EBEBEB"
                d="M453.31 337.8h-193.1a5.72 5.72 0 0 1-5.71-5.71V60.66a5.72 5.72 0 0 1 5.71-5.66h193.1a5.71 5.71 0 0 1 5.69 5.66v271.43a5.71 5.71 0 0 1-5.69 5.71M260.21 55.2a5.47 5.47 0 0 0-5.46 5.46v271.43a5.47 5.47 0 0 0 5.46 5.46h193.1a5.47 5.47 0 0 0 5.46-5.46V60.66a5.47 5.47 0 0 0-5.46-5.46Z"
                className="animable"
                transform-origin="356.75px 196.4px"
            ></path>
            <g id="elqebrj3aasq">
                <path
                    id="ell6i2mjd9t"
                    fill="#F0F0F0"
                    d="M270.76 182.95h135.3v198.38h-135.3z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="338.41px 282.14px"
                ></path>
            </g>
            <g id="el5kn49rbagfy">
                <path
                    id="elyh8ziuyfe"
                    fill="#E0E0E0"
                    d="M275.54 189.19h125.74v36.64H275.54z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="338.41px 207.51px"
                ></path>
            </g>
            <g id="elxpnjrm2g5s9">
                <path
                    id="el1be8pry1zrz"
                    fill="#EBEBEB"
                    d="M394.14 195.12h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="397.71px 210.475px"
                ></path>
            </g>
            <g id="elgomjubw1esi">
                <path
                    id="el4sf8y7q20cw"
                    fill="#EBEBEB"
                    d="M359.6 195.12h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="363.17px 210.475px"
                ></path>
            </g>
            <g id="elc83ujybwoaf">
                <path
                    id="elo5df90czqdh"
                    fill="#EBEBEB"
                    d="M317.73 194.74h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(-170.22)"
                    transform-origin="321.3px 210.095px"
                ></path>
            </g>
            <g id="eld0wapb8mc4a">
                <path
                    id="elflmdizkg3xa"
                    fill="#EBEBEB"
                    d="M385.29 199.17h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="388.86px 212.5px"
                ></path>
            </g>
            <g id="elnn11lq1yivp">
                <path
                    id="elaojkyeih53c"
                    fill="#EBEBEB"
                    d="M368.87 199.17h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="372.44px 212.5px"
                ></path>
            </g>
            <g id="elcmufwe10zcl">
                <path
                    id="elcis5m8qgda"
                    fill="#EBEBEB"
                    d="M327.43 199.17h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="331px 212.5px"
                ></path>
            </g>
            <g id="eluwi4idwxbv">
                <path
                    id="el5u05aghwsw8"
                    fill="#EBEBEB"
                    d="M347.24 198.71h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(-167.47)"
                    transform-origin="350.81px 212.04px"
                ></path>
            </g>
            <g id="elkq26utadned">
                <path
                    id="el7ru8pv0c6kc"
                    fill="#EBEBEB"
                    d="M379.11 193.6h3.57v32.23h-3.57z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="380.895px 209.715px"
                ></path>
            </g>
            <g id="elcsxvaqny264">
                <path
                    id="elz0rphqr0d9"
                    fill="#EBEBEB"
                    d="M336.62 193.6h3.57v32.23h-3.57z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="338.405px 209.715px"
                ></path>
            </g>
            <path
                id="elni5hma7v5j"
                fill="#E0E0E0"
                d="M275.54 231.63h125.74v36.64H275.54z"
                className="animable"
                transform-origin="338.41px 249.95px"
            ></path>
            <path
                id="el3h8smislamh"
                fill="#EBEBEB"
                d="M275.54 237.56h7.14v30.71h-7.14z"
                className="animable"
                transform-origin="279.11px 252.915px"
            ></path>
            <path
                id="elpl9iheob09n"
                fill="#EBEBEB"
                d="M310.08 237.56h7.14v30.71h-7.14z"
                className="animable"
                transform-origin="313.65px 252.915px"
            ></path>
            <g id="elqybk8g5vsvi">
                <path
                    id="elpn6tg59juam"
                    fill="#EBEBEB"
                    d="M351.95 237.18h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(-9.78)"
                    transform-origin="355.52px 252.535px"
                ></path>
            </g>
            <path
                id="elklj8wyxrbzr"
                fill="#EBEBEB"
                d="M284.39 241.61h7.14v26.66h-7.14z"
                className="animable"
                transform-origin="287.96px 254.94px"
            ></path>
            <path
                id="elzdbha33852"
                fill="#EBEBEB"
                d="M300.81 241.61h7.14v26.66h-7.14z"
                className="animable"
                transform-origin="304.38px 254.94px"
            ></path>
            <path
                id="el8qedsnykgva"
                fill="#EBEBEB"
                d="M342.25 241.61h7.14v26.66h-7.14z"
                className="animable"
                transform-origin="345.82px 254.94px"
            ></path>
            <g id="el171krfi2bv5h">
                <path
                    id="elockbhibw3pn"
                    fill="#EBEBEB"
                    d="M322.44 241.15h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(-12.53)"
                    transform-origin="326.01px 254.48px"
                ></path>
            </g>
            <path
                id="elq0b0tbwy6hs"
                fill="#EBEBEB"
                d="M294.14 236.04h3.57v32.23h-3.57z"
                className="animable"
                transform-origin="295.925px 252.155px"
            ></path>
            <path
                id="elajnwqck1map"
                fill="#EBEBEB"
                d="M336.62 236.04h3.57v32.23h-3.57z"
                className="animable"
                transform-origin="338.405px 252.155px"
            ></path>
            <g id="elfo4imc9o31">
                <path
                    id="elrybaipmt1r7"
                    fill="#EBEBEB"
                    d="M394.14 237.56h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="397.71px 252.915px"
                ></path>
            </g>
            <g id="elkod6g7v9byn">
                <path
                    id="el8lci9bhs6uq"
                    fill="#EBEBEB"
                    d="M385.29 241.61h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="388.86px 254.94px"
                ></path>
            </g>
            <g id="elsubrfjivdse">
                <path
                    id="el26m5303tixu"
                    fill="#EBEBEB"
                    d="M368.87 241.61h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="372.44px 254.94px"
                ></path>
            </g>
            <g id="elieo6awky5u">
                <path
                    id="el1bqltoluuat"
                    fill="#EBEBEB"
                    d="M379.11 236.04h3.57v32.23h-3.57z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="380.895px 252.155px"
                ></path>
            </g>
            <g id="elrd0efbkit9">
                <path
                    id="elht51o4ngq6m"
                    fill="#E0E0E0"
                    d="M275.54 274.07h125.74v36.64H275.54z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="338.41px 292.39px"
                ></path>
            </g>
            <g id="elh5h40u5plwv">
                <path
                    id="elrfiy8j8c39"
                    fill="#EBEBEB"
                    d="M321.97 280h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="325.54px 295.355px"
                ></path>
            </g>
            <g id="el7f5decihtwv">
                <path
                    id="el2s0ifhhtzy6"
                    fill="#EBEBEB"
                    d="M280.1 279.62h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(-170.22)"
                    transform-origin="283.67px 294.975px"
                ></path>
            </g>
            <g id="el1avwlislwym">
                <path
                    id="ellb1x2dxwzfp"
                    fill="#EBEBEB"
                    d="M347.65 284.05h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="351.22px 297.38px"
                ></path>
            </g>
            <g id="elob1ca9plva">
                <path
                    id="eliqe4dnwsspk"
                    fill="#EBEBEB"
                    d="M331.24 284.05h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="334.81px 297.38px"
                ></path>
            </g>
            <g id="el4vxgns0r7wh">
                <path
                    id="el8fx7laizh6r"
                    fill="#EBEBEB"
                    d="M289.8 284.05h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="293.37px 297.38px"
                ></path>
            </g>
            <g id="el28p731uf9qe">
                <path
                    id="eld3a6ggwj126"
                    fill="#EBEBEB"
                    d="M309.61 283.59h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(-167.47)"
                    transform-origin="313.18px 296.92px"
                ></path>
            </g>
            <g id="el99mnlwz7xyi">
                <path
                    id="el70h4n0mtg69"
                    fill="#EBEBEB"
                    d="M341.48 278.48h3.57v32.23h-3.57z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="343.265px 294.595px"
                ></path>
            </g>
            <g id="el6wimgrkc49">
                <path
                    id="elweo16ev9uqo"
                    fill="#EBEBEB"
                    d="M298.99 278.48h3.57v32.23h-3.57z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="300.775px 294.595px"
                ></path>
            </g>
            <g id="eld4hwlk5y03">
                <path
                    id="eldiqyq0eqi4"
                    fill="#EBEBEB"
                    d="M362.27 279.62h7.14v30.71h-7.14z"
                    className="animable"
                    transform="rotate(-170.22)"
                    transform-origin="365.84px 294.975px"
                ></path>
            </g>
            <g id="eljprqo04vdl">
                <path
                    id="elpucx2ztm4y"
                    fill="#EBEBEB"
                    d="M371.97 284.05h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="375.54px 297.38px"
                ></path>
            </g>
            <g id="el8wjkb55hlt7">
                <path
                    id="elw9i3bcgxbr"
                    fill="#EBEBEB"
                    d="M391.78 283.59h7.14v26.66h-7.14z"
                    className="animable"
                    transform="rotate(-167.47)"
                    transform-origin="395.35px 296.92px"
                ></path>
            </g>
            <g id="elu8g5vqza6al">
                <path
                    id="eln6kifkh17vc"
                    fill="#EBEBEB"
                    d="M381.17 278.48h3.57v32.23h-3.57z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="382.955px 294.595px"
                ></path>
            </g>
            <path
                id="elhx800pbhy1h"
                fill="#E0E0E0"
                d="M406.06 182.95h23.34v198.89h-23.34z"
                className="animable"
                transform-origin="417.73px 282.395px"
            ></path>
            <path
                id="el8d9p9h7rkts"
                fill="#E6E6E6"
                d="M104.42 140.24s-1.17-7.72 4.46-12.68 5.14-7.9 3.53-8.28-3.09 4.57-5.57 5.93c0 0-.08-7.06 2.44-9.66s3.83-9.3 1.44-9.42-2.64 4-3.14 6.88-3.16 7-3.16 7-.52-6.32-2.15-8.92 2.71-8.55 1-11.15-4.64 2.36-4.4 7.93 4 11.52 3.1 17.34c0 0-1.64-4.09-3.11-4.46s-3-3.08-4-4.08-2.23 2.47 0 5.69 7.93 11.83 7.06 18.8Z"
                className="animable"
                transform-origin="103.547px 120.195px"
            ></path>
            <path
                id="el34rpcwsqs6s"
                fill="#E6E6E6"
                d="m107.79 136.73 1.84 11.58a5.88 5.88 0 0 1-5.81 6.81h-2a5.88 5.88 0 0 1-5.82-6.81l1.84-11.58Z"
                className="animable"
                transform-origin="102.815px 145.925px"
            ></path>
            <g id="el1dlg4pdj83l">
                <path
                    id="elcjvb1cd6m3"
                    fill="#E0E0E0"
                    d="M79.88 150.85h130.44v6.7H79.88z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="145.1px 154.2px"
                ></path>
            </g>
            <g id="elg9j7l9i026i">
                <path
                    id="elbxmn4jnnrdp"
                    fill="#EBEBEB"
                    d="M198.57 126.14h5.75v24.7h-5.75z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="201.445px 138.49px"
                ></path>
            </g>
            <g id="elp773t0lxekq">
                <path
                    id="elvyzhlyzech"
                    fill="#EBEBEB"
                    d="M170.78 126.14h5.75v24.7h-5.75z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="173.655px 138.49px"
                ></path>
            </g>
            <g id="elvk8n1spysl">
                <path
                    id="elkfkum2lhskl"
                    fill="#EBEBEB"
                    d="M137.1 125.83h5.75v24.7h-5.75z"
                    className="animable"
                    transform="rotate(-170.22)"
                    transform-origin="139.975px 138.18px"
                ></path>
            </g>
            <g id="ele1oxxxqombm">
                <path
                    id="el2f9vhuemnar"
                    fill="#EBEBEB"
                    d="M191.45 129.4h5.75v21.45h-5.75z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="194.325px 140.125px"
                ></path>
            </g>
            <g id="elgr4u0s2ksae">
                <path
                    id="el5cy6b5byqm3"
                    fill="#EBEBEB"
                    d="M178.24 129.4h5.75v21.45h-5.75z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="181.115px 140.125px"
                ></path>
            </g>
            <g id="el6ciptqprncu">
                <path
                    id="el44cbtvelum5"
                    fill="#EBEBEB"
                    d="M144.9 129.4h5.75v21.45h-5.75z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="147.775px 140.125px"
                ></path>
            </g>
            <g id="ellkx07nzsl4">
                <path
                    id="el861yzar0knq"
                    fill="#EBEBEB"
                    d="M160.84 129.03h5.75v21.45h-5.75z"
                    className="animable"
                    transform="rotate(-167.47)"
                    transform-origin="163.715px 139.755px"
                ></path>
            </g>
            <g id="elyg64wc0ofed">
                <path
                    id="el3oonqpo890v"
                    fill="#EBEBEB"
                    d="M186.48 124.92h2.87v25.93h-2.87z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="187.915px 137.885px"
                ></path>
            </g>
            <g id="el3oo76hgr2fm">
                <path
                    id="el2cole8zgkk"
                    fill="#EBEBEB"
                    d="M152.3 124.92h2.87v25.93h-2.87z"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="153.735px 137.885px"
                ></path>
            </g>
            <path
                id="ell1szkefxec"
                fill="#E0E0E0"
                d="M79.88 200.88h130.44v6.7H79.88z"
                className="animable"
                transform-origin="145.1px 204.23px"
            ></path>
            <path
                id="elccz7epc4rko"
                fill="#EBEBEB"
                d="M85.88 176.18h5.75v24.7h-5.75z"
                className="animable"
                transform-origin="88.755px 188.53px"
            ></path>
            <path
                id="elegzn060f43"
                fill="#EBEBEB"
                d="M113.67 176.18h5.75v24.7h-5.75z"
                className="animable"
                transform-origin="116.545px 188.53px"
            ></path>
            <g id="el6mh860iyovd">
                <path
                    id="elbj1hlsqi5bs"
                    fill="#EBEBEB"
                    d="M147.35 175.87h5.75v24.7h-5.75z"
                    className="animable"
                    transform="rotate(-9.78)"
                    transform-origin="150.225px 188.22px"
                ></path>
            </g>
            <path
                id="el4l0otajwgc6"
                fill="#EBEBEB"
                d="M93 179.43h5.75v21.45H93z"
                className="animable"
                transform-origin="95.875px 190.155px"
            ></path>
            <path
                id="el9e0gea5nvkd"
                fill="#EBEBEB"
                d="M106.21 179.43h5.75v21.45h-5.75z"
                className="animable"
                transform-origin="109.085px 190.155px"
            ></path>
            <path
                id="elznngvdvnq67"
                fill="#EBEBEB"
                d="M139.55 179.43h5.75v21.45h-5.75z"
                className="animable"
                transform-origin="142.425px 190.155px"
            ></path>
            <g id="elz3mb0oibuva">
                <path
                    id="el3znellp27do"
                    fill="#EBEBEB"
                    d="M123.61 179.06h5.75v21.45h-5.75z"
                    className="animable"
                    transform="rotate(-12.53)"
                    transform-origin="126.485px 189.785px"
                ></path>
            </g>
            <path
                id="eldvhp1wclbim"
                fill="#EBEBEB"
                d="M100.84 174.95h2.87v25.93h-2.87z"
                className="animable"
                transform-origin="102.275px 187.915px"
            ></path>
            <path
                id="elqo6w2w0a9hh"
                fill="#EBEBEB"
                d="M135.02 174.95h2.87v25.93h-2.87z"
                className="animable"
                transform-origin="136.455px 187.915px"
            ></path>
            <path
                id="elc6xile5br8v"
                fill="#EBEBEB"
                d="M169.8 181.33h28v19.33h-28z"
                className="animable"
                transform-origin="183.8px 190.995px"
            ></path>
            <circle
                id="elppii9e6lweo"
                cx="345.67"
                cy="120.53"
                r="19.53"
                fill="#E0E0E0"
                className="animable"
                transform-origin="345.67px 120.53px"
            ></circle>
            <circle
                id="elrxhynatmqo"
                cx="345.67"
                cy="120.53"
                r="16.61"
                fill="#F0F0F0"
                className="animable"
                transform-origin="345.67px 120.53px"
            ></circle>
            <path
                id="elbp8cdoiwwfi"
                fill="#F0F0F0"
                d="M344.89 109.14v11.61l-7.7-4.36"
                className="animable"
                transform-origin="341.04px 114.945px"
            ></path>
            <path
                id="els2fc73tqop"
                fill="#E0E0E0"
                d="M344.89 121.75a1.05 1.05 0 0 1-.49-.13l-7.7-4.36a1 1 0 0 1-.38-1.36 1 1 0 0 1 1.37-.38l6.2 3.51v-9.89a1 1 0 1 1 2 0v11.61a1 1 0 0 1-1 1"
                className="animable"
                transform-origin="341.041px 114.945px"
            ></path>
        </g>
        <g id="freepik--Shadow--inject-62" className="animable">
            <ellipse
                id="freepik--path--inject-62"
                cx="250"
                cy="416.24"
                fill="#F5F5F5"
                className="animable"
                rx="193.89"
                ry="11.32"
                transform-origin="250px 416.24px"
            ></ellipse>
        </g>
        <g id="freepik--Test--inject-62" className="animable">
            <path
                id="elmx252ak09qh"
                fill="#FF97D2"
                d="M223.49 127.68h199.02v188.44H223.49z"
                className="animable"
                transform-origin="323px 221.9px"
            ></path>
            <g id="elkhfnl2rdarl">
                <path
                    id="elvfeh3vo0h49"
                    fill="#FFF"
                    d="M223.49 127.68h199.02v188.44H223.49z"
                    className="animable"
                    opacity="0.7"
                    style={{ isolation: "isolate" }}
                    transform-origin="323px 221.9px"
                ></path>
            </g>
            <path
                id="el1530nq3defh"
                fill="#FF97D2"
                d="M223.49 127.68h199.02v9.59H223.49z"
                className="animable"
                transform-origin="323px 132.475px"
            ></path>
            <g id="elx91dupeolf">
                <path
                    id="elzbxa9r874eo"
                    d="M415.93 137.28h6.58V316.3h-6.58z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="419.22px 226.79px"
                ></path>
            </g>
            <g id="eljs5mb55xcv">
                <rect
                    id="elyzx232wbs2"
                    width="3.96"
                    height="24.94"
                    x="417.31"
                    y="141.52"
                    fill="#FFF"
                    className="animable"
                    opacity="0.6"
                    rx="1.68"
                    style={{ isolation: "isolate" }}
                    transform-origin="419.29px 153.99px"
                ></rect>
            </g>
            <g id="el8jq7pn5z8b7">
                <path
                    id="elxcsdu74mkf"
                    d="M411.58 261h-184a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.5h184a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="319.58px 260.5px"
                ></path>
            </g>
            <g id="elo6ldrozmve">
                <path
                    id="elaur03gd2nr"
                    d="M411.58 218h-184a.51.51 0 0 1-.5-.5.5.5 0 0 1 .5-.5h184a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="319.58px 217.5px"
                ></path>
            </g>
            <path
                id="elaeotjie1vy"
                fill="#FF97D2"
                d="M227.63 141.51h183.96v28.13H227.63z"
                className="animable"
                transform-origin="319.61px 155.575px"
            ></path>
            <g id="elb7r68scjo2g">
                <path
                    id="elc6wabthochb"
                    fill="#FFF"
                    d="M420.22 132.48a2.41 2.41 0 1 1-2.41-2.41 2.41 2.41 0 0 1 2.41 2.41"
                    className="animable"
                    opacity="0.6"
                    style={{ isolation: "isolate" }}
                    transform-origin="417.81px 132.48px"
                ></path>
            </g>
            <g id="elosbz0iydjf">
                <path
                    id="eljr4x6nmcek"
                    fill="#FFF"
                    d="M411.72 132.48a2.41 2.41 0 1 1-2.41-2.41 2.41 2.41 0 0 1 2.41 2.41"
                    className="animable"
                    opacity="0.6"
                    style={{ isolation: "isolate" }}
                    transform-origin="409.31px 132.48px"
                ></path>
            </g>
            <g id="elm08u6bx5m7">
                <path
                    id="ela6ois0p95c"
                    fill="#FFF"
                    d="M403.22 132.48a2.41 2.41 0 1 1-2.41-2.41 2.41 2.41 0 0 1 2.41 2.41"
                    className="animable"
                    opacity="0.6"
                    style={{ isolation: "isolate" }}
                    transform-origin="400.81px 132.48px"
                ></path>
            </g>
            <g id="el0kjie8s9e19">
                <path
                    id="eloablfnnaf6g"
                    d="M235.51 188.48a5.89 5.89 0 1 1 5.89-5.89 5.9 5.9 0 0 1-5.89 5.89"
                    className="animable"
                    opacity="0.4"
                    style={{ isolation: "isolate" }}
                    transform-origin="235.51px 182.59px"
                ></path>
            </g>
            <path
                id="el5dinpzvy2g6"
                fill="#FFF"
                d="M236.23 180.35v4.47h-1v-3.64h-.89v-.83Z"
                className="animable"
                transform-origin="235.285px 182.585px"
            ></path>
            <g id="ela540d7vo4z">
                <rect
                    id="el52ehrunldyq"
                    width="158.97"
                    height="2.99"
                    x="245.8"
                    y="176.88"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="325.285px 178.375px"
                ></rect>
            </g>
            <g id="elujsn8wq76jl">
                <rect
                    id="ell6lszxclpw"
                    width="158.97"
                    height="2.99"
                    x="245.8"
                    y="184.65"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="325.285px 186.145px"
                ></rect>
            </g>
            <g id="el9wiw6v3oqcb">
                <rect
                    id="elc4gczj7symq"
                    width="104.77"
                    height="2.99"
                    x="245.8"
                    y="192.41"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="298.185px 193.905px"
                ></rect>
            </g>
            <g id="elxj6w3777of">
                <circle
                    id="elrz7tt5wdw3g"
                    cx="248.54"
                    cy="207.31"
                    r="2.73"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="248.54px 207.31px"
                ></circle>
            </g>
            <path
                id="elegn6e2ckkc4"
                fill="#FFF"
                d="M250.42 207.31a1.89 1.89 0 1 1-1.88-1.88 1.88 1.88 0 0 1 1.88 1.88"
                className="animable"
                transform-origin="248.53px 207.32px"
            ></path>
            <g id="elkcgvhl75a4">
                <rect
                    id="el0wj8krnw9t4o"
                    width="28.74"
                    height="2.99"
                    x="256.32"
                    y="205.82"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="270.69px 207.315px"
                ></rect>
            </g>
            <g id="elaxmpsou9xf">
                <path
                    id="elx3jr26au70s"
                    d="M306.74 207.25a2.73 2.73 0 1 1-2.73-2.73 2.73 2.73 0 0 1 2.73 2.73"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="304.01px 207.25px"
                ></path>
            </g>
            <path
                id="eltd3s0cb9d1i"
                fill="#FF97D2"
                d="M305.9 207.25a1.89 1.89 0 1 1-1.89-1.88 1.89 1.89 0 0 1 1.89 1.88"
                className="animable"
                transform-origin="304.01px 207.26px"
            ></path>
            <g id="el5np2oxzlcc5">
                <rect
                    id="elzw7ugegauyg"
                    width="28.75"
                    height="2.99"
                    x="311.8"
                    y="205.76"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="326.175px 207.255px"
                ></rect>
            </g>
            <g id="elz0zlwq43ed">
                <path
                    id="el0d5uuozf9fg"
                    d="M362.22 207.19a2.73 2.73 0 1 1-2.73-2.73 2.73 2.73 0 0 1 2.73 2.73"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="359.49px 207.19px"
                ></path>
            </g>
            <path
                id="el4jzrnv52fm6"
                fill="#FFF"
                d="M361.38 207.19a1.89 1.89 0 1 1-1.89-1.89 1.89 1.89 0 0 1 1.89 1.89"
                className="animable"
                transform-origin="359.49px 207.19px"
            ></path>
            <g id="eldy55y7pxhhn">
                <rect
                    id="el45cpw6cn1h5"
                    width="28.74"
                    height="2.99"
                    x="367.28"
                    y="205.69"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="381.65px 207.185px"
                ></rect>
            </g>
            <g id="el8kqxpgqxjl7">
                <circle
                    id="elkqyk5c3mqea"
                    cx="235.51"
                    cy="232.41"
                    r="5.89"
                    className="animable"
                    opacity="0.4"
                    style={{ isolation: "isolate" }}
                    transform-origin="235.51px 232.41px"
                ></circle>
            </g>
            <path
                id="elie7wyduogn"
                fill="#FFF"
                d="M237.21 233.84v.84h-3.37V234l1.72-1.63c.4-.38.47-.61.47-.82s-.24-.56-.72-.56a1.09 1.09 0 0 0-.92.45l-.75-.49a2.08 2.08 0 0 1 1.77-.83c1 0 1.66.51 1.66 1.32a1.77 1.77 0 0 1-.75 1.41l-1 1Z"
                className="animable"
                transform-origin="235.425px 232.399px"
            ></path>
            <g id="eluujx1m6pa1c">
                <rect
                    id="elqw6qrpgb60d"
                    width="158.97"
                    height="2.99"
                    x="245.8"
                    y="226.73"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="325.285px 228.225px"
                ></rect>
            </g>
            <g id="elxnq1fxcimr">
                <rect
                    id="elxz957kbmiae"
                    width="32.06"
                    height="2.99"
                    x="245.8"
                    y="234.49"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="261.83px 235.985px"
                ></rect>
            </g>
            <g id="el2fjdraz6wv1">
                <circle
                    id="el1equ21b78e2"
                    cx="248.54"
                    cy="249.27"
                    r="2.73"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="248.54px 249.27px"
                ></circle>
            </g>
            <circle
                id="elnqjtm5h4ht"
                cx="248.54"
                cy="249.27"
                r="1.89"
                fill="#FFF"
                className="animable"
                transform-origin="248.54px 249.27px"
            ></circle>
            <g id="el53fit88caxt">
                <rect
                    id="el8ge3blk2bgx"
                    width="28.74"
                    height="2.99"
                    x="256.32"
                    y="247.78"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="270.69px 249.275px"
                ></rect>
            </g>
            <g id="eleun35xgisjc">
                <circle
                    id="el3mup38z244"
                    cx="304.01"
                    cy="249.21"
                    r="2.73"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="304.01px 249.21px"
                ></circle>
            </g>
            <circle
                id="elum3mojlqf5a"
                cx="304.01"
                cy="249.21"
                r="1.89"
                fill="#FFF"
                className="animable"
                transform-origin="304.01px 249.21px"
            ></circle>
            <g id="eltzcgs7mhw7">
                <rect
                    id="elvqq6ci3wh1"
                    width="28.75"
                    height="2.99"
                    x="311.8"
                    y="247.71"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="326.175px 249.205px"
                ></rect>
            </g>
            <g id="elwau7qoqrc3d">
                <path
                    id="elj3fjosf84u"
                    d="M362.22 249.15a2.73 2.73 0 1 1-2.73-2.73 2.73 2.73 0 0 1 2.73 2.73"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="359.49px 249.15px"
                ></path>
            </g>
            <path
                id="elkbjyfm5p0g"
                fill="#FF97D2"
                d="M361.38 249.15a1.89 1.89 0 1 1-1.89-1.89 1.89 1.89 0 0 1 1.89 1.89"
                className="animable"
                transform-origin="359.49px 249.15px"
            ></path>
            <g id="el2d25gpbb8m8">
                <rect
                    id="elhp2ifx91zsb"
                    width="28.74"
                    height="2.99"
                    x="367.28"
                    y="247.65"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="381.65px 249.145px"
                ></rect>
            </g>
            <g id="elgqbjvfhhr8o">
                <path
                    id="elui7kaenpbi"
                    d="M235.51 281.56a5.89 5.89 0 1 1 5.89-5.89 5.89 5.89 0 0 1-5.89 5.89"
                    className="animable"
                    opacity="0.4"
                    style={{ isolation: "isolate" }}
                    transform-origin="235.51px 275.67px"
                ></path>
            </g>
            <path
                id="eli1t1gxo4c3m"
                fill="#FFF"
                d="M237.17 276.5c0 .75-.58 1.44-1.85 1.44a3 3 0 0 1-1.7-.48l.4-.79a2.2 2.2 0 0 0 1.27.4c.52 0 .84-.21.84-.57s-.25-.55-.84-.55h-.47v-.68l.92-1h-1.9v-.83H237v.67l-1 1.15a1.26 1.26 0 0 1 1.17 1.24"
                className="animable"
                transform-origin="235.395px 275.69px"
            ></path>
            <g id="elgc9b6uwho2">
                <rect
                    id="elj70e9x7fxq8"
                    width="158.97"
                    height="2.99"
                    x="245.8"
                    y="269.95"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="325.285px 271.445px"
                ></rect>
            </g>
            <g id="el9jtpbe3cv0d">
                <rect
                    id="ele7dx56nq37d"
                    width="158.97"
                    height="2.99"
                    x="245.8"
                    y="277.71"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="325.285px 279.205px"
                ></rect>
            </g>
            <g id="elhrra39p4she">
                <rect
                    id="eluxymicyzweh"
                    width="80.77"
                    height="2.99"
                    x="245.8"
                    y="285.48"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="286.185px 286.975px"
                ></rect>
            </g>
            <g id="el0accynbhj9nf">
                <rect
                    id="eld7vnzlh8a6b"
                    width="5.46"
                    height="5.46"
                    x="301.28"
                    y="297.84"
                    className="animable"
                    opacity="0.4"
                    rx="0.4"
                    style={{ isolation: "isolate" }}
                    transform-origin="304.01px 300.57px"
                ></rect>
            </g>
            <g id="elaxx98q21y5a">
                <path
                    id="el6awke0py2y4"
                    fill="#FFF"
                    d="M301.94 298.5h4.15v4.15h-4.15z"
                    className="animable"
                    style={{ isolation: "isolate" }}
                    transform="rotate(90)"
                    transform-origin="304.015px 300.575px"
                ></path>
            </g>
            <g id="elbje7dwxfcww">
                <rect
                    id="elvgnwgkhhzoj"
                    width="28.75"
                    height="2.99"
                    x="311.8"
                    y="299.08"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="326.175px 300.575px"
                ></rect>
            </g>
            <path
                id="elspa5xn5g5hf"
                fill="#FF97D2"
                d="M303.79 301.77a.23.23 0 0 1-.17-.07l-1-.94a.26.26 0 0 1 0-.36.25.25 0 0 1 .36 0l.85.77 1.45-1.72a.25.25 0 0 1 .39.32l-1.67 1.91a.28.28 0 0 1-.17.09Z"
                className="animable"
                transform-origin="304.137px 300.565px"
            ></path>
            <g id="elm0f5o4u2lce">
                <rect
                    id="el0ztr93bx81fo"
                    width="5.46"
                    height="5.46"
                    x="356.76"
                    y="297.78"
                    className="animable"
                    opacity="0.4"
                    rx="0.4"
                    style={{ isolation: "isolate" }}
                    transform-origin="359.49px 300.51px"
                ></rect>
            </g>
            <g id="elr1e1e6uglaa">
                <path
                    id="el60c20x27qm"
                    fill="#FFF"
                    d="M357.42 298.44h4.15v4.15h-4.15z"
                    className="animable"
                    style={{ isolation: "isolate" }}
                    transform="rotate(90)"
                    transform-origin="359.495px 300.515px"
                ></path>
            </g>
            <g id="elu6k7te371eb">
                <rect
                    id="ela8xkpp8v7kd"
                    width="28.74"
                    height="2.99"
                    x="367.28"
                    y="299.01"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="381.65px 300.505px"
                ></rect>
            </g>
            <path
                id="elnnhkzax7otp"
                fill="#FF97D2"
                d="M359.27 301.71a.28.28 0 0 1-.17-.07l-1-.95a.25.25 0 1 1 .34-.36l.84.77 1.46-1.72a.25.25 0 1 1 .38.32l-1.62 1.92a.3.3 0 0 1-.18.09Z"
                className="animable"
                transform-origin="359.596px 300.489px"
            ></path>
            <g id="elwf7yd9pwf5h">
                <rect
                    id="elq8u6mhwgimr"
                    width="5.46"
                    height="5.46"
                    x="245.8"
                    y="297.9"
                    className="animable"
                    opacity="0.4"
                    rx="0.4"
                    style={{ isolation: "isolate" }}
                    transform-origin="248.53px 300.63px"
                ></rect>
            </g>
            <g id="el5p5wi26oei">
                <path
                    id="elz89vgrhfux"
                    fill="#FFF"
                    d="M246.46 298.56h4.15v4.15h-4.15z"
                    className="animable"
                    style={{ isolation: "isolate" }}
                    transform="rotate(90)"
                    transform-origin="248.535px 300.635px"
                ></path>
            </g>
            <g id="eluu496s562x">
                <rect
                    id="el31rmh9zp945"
                    width="28.74"
                    height="2.99"
                    x="256.32"
                    y="299.14"
                    className="animable"
                    opacity="0.4"
                    rx="1.14"
                    style={{ isolation: "isolate" }}
                    transform-origin="270.69px 300.635px"
                ></rect>
            </g>
            <path
                id="elyuk14oj7078"
                fill="#FFF"
                d="M236.45 154.68a3.83 3.83 0 1 1 3.82 3.61 3.61 3.61 0 0 1-3.82-3.61m6 0a2.19 2.19 0 1 0-2.19 2.23 2.14 2.14 0 0 0 2.2-2.23Z"
                className="animable"
                transform-origin="240.274px 154.463px"
            ></path>
            <path
                id="els5ibjgs3ixi"
                fill="#FFF"
                d="M250.68 155.1v3.07h-1.55v-2.83c0-.87-.4-1.27-1.09-1.27s-1.29.46-1.29 1.45v2.65h-1.55v-5.37h1.48v.63a2.36 2.36 0 0 1 1.78-.71 2.1 2.1 0 0 1 2.22 2.38"
                className="animable"
                transform-origin="247.95px 155.443px"
            ></path>
            <path
                id="el0bwznk8hpx48"
                fill="#FFF"
                d="M252.09 150.77h1.55v7.4h-1.55Z"
                className="animable"
                transform-origin="252.865px 154.47px"
            ></path>
            <path
                id="elvni13up487"
                fill="#FFF"
                d="M254.9 151.19a.89.89 0 0 1 1-.87.87.87 0 0 1 1 .84 1 1 0 0 1-1.93 0Zm.19 1.61h1.56v5.37h-1.56Z"
                className="animable"
                transform-origin="255.9px 154.24px"
            ></path>
            <path
                id="eltseqdm316ae"
                fill="#FFF"
                d="M263.58 155.1v3.07H262v-2.83c0-.87-.4-1.27-1.09-1.27s-1.28.46-1.28 1.45v2.65h-1.56v-5.37h1.49v.63a2.33 2.33 0 0 1 1.77-.71 2.11 2.11 0 0 1 2.25 2.38"
                className="animable"
                transform-origin="260.834px 155.442px"
            ></path>
            <path
                id="elsgq79ni62l"
                fill="#FFF"
                d="M270.27 155.93h-4.06a1.42 1.42 0 0 0 1.53 1.07 1.86 1.86 0 0 0 1.35-.51l.83.89a2.82 2.82 0 0 1-2.22.87 2.79 2.79 0 0 1-3.06-2.76 2.74 2.74 0 0 1 2.87-2.77 2.66 2.66 0 0 1 2.79 2.79c0 .12-.02.29-.03.42m-4.08-.91h2.64a1.34 1.34 0 0 0-2.64 0"
                className="animable"
                transform-origin="267.472px 155.49px"
            ></path>
            <path
                id="elf2fbzdv71xg"
                fill="#FFF"
                d="M275.71 152.5h-2.23v-1.31h6.08v1.31h-2.23v5.67h-1.62Z"
                className="animable"
                transform-origin="276.52px 154.68px"
            ></path>
            <path
                id="elrs38zy64twm"
                fill="#FFF"
                d="M285 155.93h-4.06a1.42 1.42 0 0 0 1.53 1.07 1.86 1.86 0 0 0 1.35-.51l.83.89a2.82 2.82 0 0 1-2.22.87 2.79 2.79 0 0 1-3.06-2.76 2.74 2.74 0 0 1 2.86-2.77 2.66 2.66 0 0 1 2.8 2.79c-.03.12-.03.29-.03.42m-4.08-.91h2.64a1.34 1.34 0 0 0-2.64 0"
                className="animable"
                transform-origin="282.202px 155.49px"
            ></path>
            <path
                id="elyknk9nuz2wl"
                fill="#FFF"
                d="m285.54 157.67.52-1.11a3.8 3.8 0 0 0 1.87.51c.72 0 1-.19 1-.48 0-.88-3.25 0-3.25-2.13 0-1 .92-1.74 2.49-1.74a4.4 4.4 0 0 1 2.06.47l-.52 1.11a3 3 0 0 0-1.54-.4c-.7 0-1 .22-1 .5 0 .92 3.24 0 3.24 2.15 0 1-.93 1.7-2.53 1.7a4.6 4.6 0 0 1-2.34-.58"
                className="animable"
                transform-origin="287.975px 155.485px"
            ></path>
            <path
                id="el1we16wfynbs"
                fill="#FFF"
                d="M294.82 157.91a2.23 2.23 0 0 1-1.27.34 1.76 1.76 0 0 1-2-1.92v-2.21h-.83v-1.2h.83v-1.3h1.55v1.3h1.34v1.2h-1.34v2.19a.62.62 0 0 0 .67.7 1.05 1.05 0 0 0 .63-.2Z"
                className="animable"
                transform-origin="292.77px 154.944px"
            ></path>
            <g id="elyystuohtqc">
                <circle
                    id="elfanvrkw3w7a"
                    cx="395.28"
                    cy="155.68"
                    r="7.93"
                    fill="#FFF"
                    className="animable"
                    transform="rotate(-45)"
                    transform-origin="395.28px 155.68px"
                ></circle>
            </g>
            <g id="el8gico9caprf">
                <path
                    id="el47db892r0z9"
                    d="m402.3 152-7 3.7v-7.93a7.93 7.93 0 0 1 7 4.23"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="398.8px 151.735px"
                ></path>
            </g>
        </g>
        <g id="freepik--Plant--inject-62" className="animable">
            <path
                id="elq3vdq5c2kdc"
                fill="#263238"
                d="M380.39 399.78s4.32-20.43-3.55-31.49 7.11-.13 8.84 10.23c0 0 2.58-18.52-5.06-31.54s6.65-2.34 7.87 11.09c0 0 2.34-16.52-1.17-25.81s2.59-3.31 4.94 2.51-.73 20.23-.73 20.23 6.12-26.65 11.92-24.53-8.67 19.58-10.67 28.66c0 0 6.83-12.22 12-9.67s-8 3.81-14.08 22l-2.11 8.54s6.29-12.06 10.4-8.25-12.19 10.37-16 28.65Z"
                className="animable"
                transform-origin="390.264px 363.919px"
            ></path>
            <path
                id="elvfajpskqpb"
                fill="#263238"
                d="M381.24 401s.9-25.75 13.63-36.65-8.48-2.27-13.63 9.62c0 0 2.42-22.95 15.44-36.28s-7.27-4.77-12.72 10.94c0 0 2.12-20.48 9.09-30.55s-2.12-4.75-6.66 1.52-5.15 24.4-5.15 24.4.6-33.74-7-32.92 4.54 26 4.24 37.5c0 0-4.55-16.67-11.51-15.17s8.48 7 10.3 30.58v10.87s-3.94-16.32-10-13 11.51 16.06 10.6 39.08Z"
                className="animable"
                transform-origin="383.072px 356.033px"
            ></path>
            <g id="el57hz2lckhx4">
                <path
                    id="el19rye6o60cy"
                    fill="#FFF"
                    d="M381.24 401s.9-25.75 13.63-36.65-8.48-2.27-13.63 9.62c0 0 2.42-22.95 15.44-36.28s-7.27-4.77-12.72 10.94c0 0 2.12-20.48 9.09-30.55s-2.12-4.75-6.66 1.52-5.15 24.4-5.15 24.4.6-33.74-7-32.92 4.54 26 4.24 37.5c0 0-4.55-16.67-11.51-15.17s8.48 7 10.3 30.58v10.87s-3.94-16.32-10-13 11.51 16.06 10.6 39.08Z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="383.072px 356.033px"
                ></path>
            </g>
            <g id="elgb2j7wvqd">
                <path
                    id="el8hjghmq3fqh"
                    fill="#FF97D2"
                    d="M372.09 406h15.42a11 11 0 0 1 11 11v2.07H361.1V417a11 11 0 0 1 10.99-11"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="379.805px 412.535px"
                ></path>
            </g>
            <g id="elv6tgc56mroe">
                <rect
                    id="elnedcflzsmjm"
                    width="47.2"
                    height="11.7"
                    x="356.2"
                    y="398.47"
                    fill="#FF97D2"
                    className="animable"
                    rx="4.21"
                    transform="rotate(180)"
                    transform-origin="379.8px 404.32px"
                ></rect>
            </g>
            <g id="elre44eu1swb">
                <rect
                    id="eloj1lnm0osdl"
                    width="47.2"
                    height="11.7"
                    x="356.2"
                    y="398.47"
                    fill="#FFF"
                    className="animable"
                    opacity="0.2"
                    rx="4.21"
                    style={{ isolation: "isolate" }}
                    transform="rotate(180)"
                    transform-origin="379.8px 404.32px"
                ></rect>
            </g>
        </g>
        <g id="freepik--Table--inject-62" className="animable">
            <path
                id="elb5kb3im5sgp"
                fill="#263238"
                d="M171.71 278.47a1.81 1.81 0 0 0 1.8 2.59h47.36a4.09 4.09 0 0 0 3.61-2.59l10-28.9a2.4 2.4 0 0 0 .15-.84 1.77 1.77 0 0 0-1.95-1.75h-47.33a4.09 4.09 0 0 0-3.61 2.59Z"
                className="animable"
                transform-origin="203.08px 264.019px"
            ></path>
            <path
                id="elp667ghydnk"
                fill="#FF97D2"
                d="M221.23 279.61a2 2 0 0 0 1.77-1.27l10-28.9a1 1 0 0 0 .06-.36c0-.4-.29-.65-.75-.65H185a2 2 0 0 0-1.77 1.27l-10 28.9a.79.79 0 0 0 .05.73.73.73 0 0 0 .64.28Z"
                className="animable"
                transform-origin="203.112px 264.021px"
            ></path>
            <g id="el53m3jlw89x">
                <path
                    id="elekpkt4vzj5u"
                    fill="#FFF"
                    d="M221.23 279.61a2 2 0 0 0 1.77-1.27l10-28.9a1 1 0 0 0 .06-.36c0-.4-.29-.65-.75-.65H185a2 2 0 0 0-1.77 1.27l-10 28.9a.79.79 0 0 0 .05.73.73.73 0 0 0 .64.28Z"
                    className="animable"
                    opacity="0.8"
                    style={{ isolation: "isolate" }}
                    transform-origin="203.112px 264.021px"
                ></path>
            </g>
            <path
                id="el1iejn6h8hfh"
                fill="#263238"
                d="M151.44 278.92v1.33l9.38 2.41h59.83a1.67 1.67 0 0 0 1.67-1.67v-2.07Z"
                className="animable"
                transform-origin="186.88px 280.79px"
            ></path>
            <g id="elaaxrorfsnzq">
                <path
                    id="elcg9bib8lvjl"
                    fill="#FFF"
                    d="M201.5 278.92v1.33l9.39 2.41h-50.07l-9.38-2.41v-1.33z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="181.165px 280.79px"
                ></path>
            </g>
            <g id="el1ox8tf5fray">
                <g id="elu0a2oodkywn" className="animable" opacity="0.2">
                    <path
                        id="el62jy5bda4pw"
                        fill="#FF97D2"
                        d="M230.02 255.22h-47.87l1.86-5.22h47.87z"
                        className="animable"
                        transform-origin="207.015px 252.61px"
                    ></path>
                </g>
            </g>
            <g id="elvqn0ksll1ld">
                <g
                    id="eloequy8ttnd8"
                    className="animable"
                    opacity="0.1"
                    style={{ isolation: "isolate" }}
                >
                    <path
                        id="elra4hn2tvf7j"
                        d="M227.62 261.94h-47.87c-.14 0-.21-.11-.16-.26a.41.41 0 0 1 .34-.26h47.88c.13 0 .2.12.15.26a.38.38 0 0 1-.34.26"
                        className="animable"
                        transform-origin="203.775px 261.68px"
                    ></path>
                </g>
            </g>
            <g id="elc7ebzopfdpq">
                <g
                    id="elgt7qqjh5ubk"
                    className="animable"
                    opacity="0.1"
                    style={{ isolation: "isolate" }}
                >
                    <path
                        id="elxewc9l4brr"
                        d="M225 269.27h-47.87c-.14 0-.21-.12-.16-.26a.41.41 0 0 1 .35-.26h47.87c.14 0 .21.11.16.26a.41.41 0 0 1-.35.26"
                        className="animable"
                        transform-origin="201.16px 269.01px"
                    ></path>
                </g>
            </g>
            <g id="eljjcewxniapo">
                <g
                    id="elr3iry28lnha"
                    className="animable"
                    opacity="0.1"
                    style={{ isolation: "isolate" }}
                >
                    <path
                        id="el2yfwb0lticc"
                        d="M222.39 276.6h-47.87c-.14 0-.21-.12-.16-.26a.39.39 0 0 1 .34-.27h47.87c.14 0 .21.12.16.27a.4.4 0 0 1-.34.26"
                        className="animable"
                        transform-origin="198.545px 276.335px"
                    ></path>
                </g>
            </g>
            <path
                id="elc6zpj6yvmpa"
                fill="#263238"
                d="M206.47 418.97h5.21l9.37-130.44h-6.92z"
                className="animable"
                transform-origin="213.76px 353.75px"
            ></path>
            <g id="ele8jvn15nohq">
                <path
                    id="elu1cqu4km5j"
                    fill="#FFF"
                    d="M206.46 418.97h5.22l8.91-123.96.46-6.27h-6.92l-.37 6.27z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="213.755px 353.855px"
                ></path>
            </g>
            <g id="elkz9pwjs0sfe">
                <path
                    id="el03gycvpfzcyx"
                    d="M213.76 294.7h6.83l.46-5.96h-6.92z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="217.405px 291.72px"
                ></path>
            </g>
            <path
                id="elmrns0d44wse"
                fill="#263238"
                d="M168.2 418.97h5.21l.85-130.44h-6.91z"
                className="animable"
                transform-origin="170.805px 353.75px"
            ></path>
            <g id="elul3efzr5be">
                <path
                    id="elgunoid5a3x"
                    fill="#FFF"
                    d="m167.34 288.74.14 21.04.71 109.19h5.22l.72-109.19.13-21.04z"
                    className="animable"
                    opacity="0.3"
                    style={{ isolation: "isolate" }}
                    transform-origin="170.8px 353.855px"
                ></path>
            </g>
            <g id="el8zxqwy6u2gg">
                <path
                    id="eli23o2v84ga9"
                    d="m167.34 288.74.14 21.28h6.65l.13-21.28z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="170.8px 299.38px"
                ></path>
            </g>
            <path
                id="elw1qvd69y8ob"
                fill="#263238"
                d="M112.84 418.97h5.21l9.37-130.44h-6.92z"
                className="animable"
                transform-origin="120.13px 353.75px"
            ></path>
            <g id="elx4haii2llaj">
                <path
                    id="elu8k37qjr86a"
                    fill="#FFF"
                    d="M112.84 418.97h5.21l8.92-123.96.45-6.27h-6.92l-.37 6.27z"
                    className="animable"
                    opacity="0.3"
                    style={{ isolation: "isolate" }}
                    transform-origin="120.13px 353.855px"
                ></path>
            </g>
            <g id="el6tphkqwtuz2">
                <path
                    id="elalyzt6norxj"
                    d="M120.13 294.7h6.84l.45-5.96h-6.92z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="123.775px 291.72px"
                ></path>
            </g>
            <path
                id="elmiy5kbc5c4b"
                fill="#263238"
                d="M266.12 418.97h5.21l-7.66-130.44h-6.92z"
                className="animable"
                transform-origin="264.04px 353.75px"
            ></path>
            <g id="elph92x3ucuor">
                <path
                    id="elhsqig6wotjm"
                    fill="#FFF"
                    d="m256.75 288.74.46 6.27 8.91 123.96h5.21l-7.29-123.96-.37-6.27z"
                    className="animable"
                    opacity="0.3"
                    style={{ isolation: "isolate" }}
                    transform-origin="264.04px 353.855px"
                ></path>
            </g>
            <g id="el91liii2hxn">
                <path
                    id="el2cq5vcuxwii"
                    d="M263.67 288.74h-6.92l.46 5.96h6.83z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="260.395px 291.72px"
                ></path>
            </g>
            <g id="el1xviff4sfoh">
                <path
                    id="eltep8s6nuz7"
                    fill="#FF97D2"
                    d="M117.18 285.26H267a2.16 2.16 0 0 1 2.16 2.16v4.37H115v-4.37a2.16 2.16 0 0 1 2.18-2.16"
                    className="animable"
                    transform="rotate(180)"
                    transform-origin="192.08px 288.525px"
                ></path>
            </g>
            <g id="ela7n33g4njhp">
                <path
                    id="elcleozngjb5g"
                    d="M115.02 285.26h154.13v3.27H115.02z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform="rotate(180)"
                    transform-origin="192.085px 286.895px"
                ></path>
            </g>
            <path
                id="elgkv2ox46lr"
                fill="#FF97D2"
                d="M111.79 286.11h160.59a1.84 1.84 0 0 0 1.84-1.84 1.84 1.84 0 0 0-1.84-1.84H111.79a1.84 1.84 0 0 0-1.84 1.84 1.84 1.84 0 0 0 1.84 1.84"
                className="animable"
                transform-origin="192.085px 284.27px"
            ></path>
            <path
                id="el5m0motnmg2h"
                fill="#263238"
                d="M267.25 277.8a10.5 10.5 0 0 1-.85 4.63h-36.59v-.87h.74V274h-.74v-.87h36.59a10.8 10.8 0 0 1 .85 4.67"
                className="animable"
                transform-origin="248.535px 277.78px"
            ></path>
            <g id="elxjz0rnqk4dc">
                <path
                    id="elu6qklnbssl"
                    fill="#FFF"
                    d="M267.25 277.8a10.5 10.5 0 0 1-.85 4.63h-36.59v-.87h.74V274h-.74v-.87h36.59a10.8 10.8 0 0 1 .85 4.67"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="248.535px 277.78px"
                ></path>
            </g>
            <g id="el2nqc9udqlc6">
                <path
                    id="eljplte06m8qq"
                    d="M247.67 277.8a10.5 10.5 0 0 1-.85 4.63h-17v-.87h.74V274h-.74v-.87h17a10.8 10.8 0 0 1 .85 4.67"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="238.75px 277.78px"
                ></path>
            </g>
            <g id="eld3rtjqjvof">
                <path
                    id="el4ts9qitia4w"
                    fill="#FFF"
                    d="M245.87 277.8a8.5 8.5 0 0 1-.69 3.76h-14.63V274h14.63a8.8 8.8 0 0 1 .69 3.8"
                    className="animable"
                    opacity="0.8"
                    style={{ isolation: "isolate" }}
                    transform-origin="238.214px 277.78px"
                ></path>
            </g>
            <g id="el6imrxvqod45">
                <path
                    id="elyvrpm2fcklo"
                    fill="#FFF"
                    d="M261.29 277.8a10.5 10.5 0 0 1-.85 4.63h-6.81a10.5 10.5 0 0 0 .85-4.63 10.8 10.8 0 0 0-.85-4.64h6.81a10.8 10.8 0 0 1 .85 4.64"
                    className="animable"
                    opacity="0.6"
                    style={{ isolation: "isolate" }}
                    transform-origin="257.465px 277.795px"
                ></path>
            </g>
            <path
                id="el2dw275s5fs3"
                fill="#FF97D2"
                d="M270.51 268.53a10.5 10.5 0 0 1-.85 4.63h-36.59v-.87h.74v-7.53h-.74v-.87h36.59a10.9 10.9 0 0 1 .85 4.64"
                className="animable"
                transform-origin="251.795px 268.525px"
            ></path>
            <g id="elu8dw4mw2h">
                <path
                    id="el4p4rd6jtnar"
                    d="M250.93 268.53a10.5 10.5 0 0 1-.85 4.63h-17v-.87h.74v-7.53h-.74v-.87h17a10.9 10.9 0 0 1 .85 4.64"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="242.01px 268.525px"
                ></path>
            </g>
            <g id="eluctfxt1zlbc">
                <path
                    id="el91inmxtsbn"
                    fill="#FFF"
                    d="M249.13 268.53a8.5 8.5 0 0 1-.69 3.76h-14.63v-7.53h14.63a8.8 8.8 0 0 1 .69 3.77"
                    className="animable"
                    opacity="0.8"
                    style={{ isolation: "isolate" }}
                    transform-origin="241.474px 268.525px"
                ></path>
            </g>
            <g id="elll8gbo0pv0b">
                <path
                    id="elhc47m8v9qv"
                    d="M264.55 268.53a10.5 10.5 0 0 1-.85 4.63h-6.81a10.5 10.5 0 0 0 .85-4.63 10.9 10.9 0 0 0-.85-4.64h6.81a10.9 10.9 0 0 1 .85 4.64"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="260.725px 268.525px"
                ></path>
            </g>
        </g>
        <g id="freepik--Character--inject-62" className="animable">
            <g id="freepik--group--inject-62" className="animable">
                <path
                    id="elei35nkj9rdt"
                    fill="#EBB376"
                    d="m147.75 396.67-3.22 14.9-7.63-.13 3.19-14.77z"
                    className="animable"
                    transform-origin="142.325px 404.12px"
                ></path>
                <g id="elk3brr91fdwd">
                    <path
                        id="elk3pmsisabl"
                        d="m147.76 396.67-1.6 7.37-7.56-.51 1.49-6.86z"
                        className="animable"
                        opacity="0.2"
                        style={{ isolation: "isolate" }}
                        transform-origin="143.18px 400.355px"
                    ></path>
                </g>
                <path
                    id="el8dr4398bck5"
                    fill="#FF97D2"
                    d="M145.68 411.19h.16s.17.06.19.08a.07.07 0 0 0 .06 0 9 9 0 0 0 2 .4 2 2 0 0 0 1.45-.29.93.93 0 0 0 .28-1 .7.7 0 0 0-.38-.54 3.18 3.18 0 0 0-2.12.39 2.7 2.7 0 0 0 .75-1.74.71.71 0 0 0-.64-.58 1.1 1.1 0 0 0-.85.2c-.8.69-.93 2.85-.93 3Zm.82-.44-.15.09a3.77 3.77 0 0 1 .64-2.33.5.5 0 0 1 .39-.14h.09c.25 0 .31.17.31.28a3.56 3.56 0 0 1-1.28 2.1m.11.38c.92-.51 2.23-1.06 2.72-.84a.33.33 0 0 1 .18.26.67.67 0 0 1-.17.63c-.34.32-1.34.3-2.73-.05"
                    className="animable"
                    transform-origin="147.758px 409.798px"
                ></path>
                <path
                    id="elm2zc8gg7ep8"
                    fill="#263238"
                    d="m145.5 410.26-8.55-.53a.54.54 0 0 0-.6.48l-.84 6.75a1.36 1.36 0 0 0 1.25 1.43c3 .13 4.42.05 8.18.25A72 72 0 0 0 155 419c3.19-.31 2.8-3.46 1.42-3.61-3.26-.37-7.58-2.77-9.63-4.59a2.17 2.17 0 0 0-1.29-.54"
                    className="animable"
                    transform-origin="146.477px 414.384px"
                ></path>
                <path
                    id="elsa04kskqiqe"
                    fill="#EBB376"
                    d="m192.42 396.67-3.22 14.9-7.64-.13 3.2-14.77z"
                    className="animable"
                    transform-origin="186.99px 404.12px"
                ></path>
                <g id="elxmt60vvooas">
                    <path
                        id="elysyigoqov3c"
                        d="m192.42 396.67-1.6 7.37-7.56-.51 1.49-6.86z"
                        className="animable"
                        opacity="0.2"
                        style={{ isolation: "isolate" }}
                        transform-origin="187.84px 400.355px"
                    ></path>
                </g>
                <path
                    id="el5gthwaoiwh"
                    fill="#FF97D2"
                    d="M190.34 411.19h.16s.17.06.2.08a.07.07 0 0 0 .06 0 9 9 0 0 0 2 .4 2 2 0 0 0 1.46-.29.93.93 0 0 0 .27-1 .67.67 0 0 0-.38-.54 3.18 3.18 0 0 0-2.12.39 2.76 2.76 0 0 0 .76-1.74.73.73 0 0 0-.65-.58 1.1 1.1 0 0 0-.85.2c-.8.69-.93 2.85-.93 3Zm.82-.44-.15.09a3.84 3.84 0 0 1 .64-2.33.52.52 0 0 1 .39-.14h.09c.25 0 .31.17.32.28a3.64 3.64 0 0 1-1.29 2.1m.11.38c.92-.51 2.23-1.06 2.72-.84a.33.33 0 0 1 .18.26.67.67 0 0 1-.16.63c-.39.32-1.39.3-2.74-.05"
                    className="animable"
                    transform-origin="192.43px 409.799px"
                ></path>
                <path
                    id="ela3hxp4zv3ml"
                    fill="#263238"
                    d="m190.16 410.26-8.55-.53a.54.54 0 0 0-.6.48l-.84 6.75a1.36 1.36 0 0 0 1.25 1.43c3 .13 4.42.05 8.18.25a72 72 0 0 0 10.05.33c3.19-.31 2.8-3.46 1.43-3.61-3.27-.37-7.59-2.77-9.63-4.59a2.17 2.17 0 0 0-1.29-.51"
                    className="animable"
                    transform-origin="191.133px 414.373px"
                ></path>
                <path
                    id="elq1xys2pyotb"
                    fill="#FF97D2"
                    d="M161.44 368.31a239 239 0 0 1-11.12 32.86l-13.94-1.06s5.72-22.34 7.79-42.8c1.28-12.63 1.17-23.08-2.53-23.89-2.33-.52-7.77-.5-14.75-.34v-26c19.58 4 39.06 11.6 40.54 17.68 2.07 8.57-1.55 26.69-5.99 43.55"
                    className="animable"
                    transform-origin="147.459px 354.125px"
                ></path>
                <g id="el20jzrqwchsz">
                    <path
                        id="ely5i3ay0ed"
                        fill="#FFF"
                        d="M161.44 368.31a239 239 0 0 1-11.12 32.86l-13.94-1.06s5.72-22.34 7.79-42.8c1.28-12.63 1.17-23.08-2.53-23.89-2.33-.52-7.77-.5-14.75-.34v-26c19.58 4 39.06 11.6 40.54 17.68 2.07 8.57-1.55 26.69-5.99 43.55"
                        className="animable"
                        opacity="0.4"
                        style={{ isolation: "isolate" }}
                        transform-origin="147.459px 354.125px"
                    ></path>
                </g>
                <g id="ela3a4ejqiqv">
                    <path
                        id="elbr5602krfp"
                        d="M161.44 368.31c-5.2-3.3-11.29-7.17-17.27-11 1.28-12.63 1.17-23.08-2.53-23.89-2.33-.52-7.77-.5-14.75-.34v-26c19.58 4 39.06 11.6 40.54 17.68 2.07 8.57-1.55 26.69-5.99 43.55"
                        className="animable"
                        opacity="0.2"
                        style={{ isolation: "isolate" }}
                        transform-origin="147.459px 337.695px"
                    ></path>
                </g>
                <path
                    id="el530y8nb46v7"
                    fill="#FF97D2"
                    d="m153.82 304.53 1.23-9.87-39.9-6.57s-13.05 25.91-6.66 38.53c5.85 11.62 68.21 4.7 77.81 6.79S181 400.1 181 400.1l14 1.07s21.54-58.12 17.11-76.4c-1.95-7.97-34.83-18.53-58.29-20.24"
                    className="animable"
                    transform-origin="159.719px 344.63px"
                ></path>
                <g id="el9wh4j4zuq9">
                    <path
                        id="elc5ex6sn876h"
                        fill="#FFF"
                        d="m153.82 304.53 1.23-9.87-39.9-6.57s-13.05 25.91-6.66 38.53c5.85 11.62 68.21 4.7 77.81 6.79S181 400.1 181 400.1l14 1.07s21.54-58.12 17.11-76.4c-1.95-7.97-34.83-18.53-58.29-20.24"
                        className="animable"
                        opacity="0.6"
                        style={{ isolation: "isolate" }}
                        transform-origin="159.719px 344.63px"
                    ></path>
                </g>
                <path
                    id="eli3yy89sa72f"
                    fill="#263238"
                    d="M175.77 224.24c-.34.59-.3 1.26.09 1.48s1-.08 1.31-.68.3-1.25-.08-1.48-.95.11-1.32.68"
                    className="animable"
                    transform-origin="176.464px 224.64px"
                ></path>
                <path
                    id="ellg1qukamolr"
                    fill="#263238"
                    d="M175.14 221.05a.5.5 0 0 1-.2-.18.42.42 0 0 1 .21-.53 4 4 0 0 1 3.67.18.4.4 0 0 1 .13.54.41.41 0 0 1-.56.11 3.17 3.17 0 0 0-2.89-.11.4.4 0 0 1-.36-.01"
                    className="animable"
                    transform-origin="176.958px 220.607px"
                ></path>
                <path
                    id="elpper4e81gn"
                    fill="#DE5753"
                    d="M176.33 223.48a24.7 24.7 0 0 0-.07 6.71 4 4 0 0 1-3.15-1.1Z"
                    className="animable"
                    transform-origin="174.72px 226.844px"
                ></path>
                <path
                    id="elcrg5n158h3"
                    fill="#E4897B"
                    d="M172.75 231.84c-.24.29-.48.57-.74.83a10.35 10.35 0 0 1-5.42 3 11 11 0 0 1-1.59.21 9.46 9.46 0 0 1-7.56-3 9.6 9.6 0 0 1-1.95-3.24c-1.86-5 0-9 2.71-15.91a10.19 10.19 0 0 1 17-3.47c5.42 5.66 1.8 16.15-2.45 21.58"
                    className="animable"
                    transform-origin="166.335px 221.472px"
                ></path>
                <g id="elker1e7z3xj">
                    <path
                        id="ely1awiu1ip5g"
                        d="M166.59 235.65a11 11 0 0 1-1.59.21 9.46 9.46 0 0 1-7.56-3 11.3 11.3 0 0 1 2.25-1.75 14.73 14.73 0 0 1 6.9 4.54"
                        className="animable"
                        opacity="0.2"
                        style={{ isolation: "isolate" }}
                        transform-origin="162.015px 233.495px"
                    ></path>
                </g>
                <path
                    id="elrxgo85m1v89"
                    fill="#E4897B"
                    d="M144.06 235.91c.68 4.9 11.38 6.73 11.38 6.73s5.28 2.4 5.5.31c-2.19-2.53-2.43-4.74-1.67-6.67a9.5 9.5 0 0 1 2.15-3.11 20 20 0 0 1 1.56-1.44l-3.27-13.4c-2.35 5.09-10.39 16.86-15.65 17.58"
                    className="animable"
                    transform-origin="153.52px 231.067px"
                ></path>
                <path
                    id="elr2jy1c0lys"
                    fill="#263238"
                    d="M174.59 206.42s2.29-.29 4 4c1.48 3.59-2 4.37-1.85 8.19s-3.33 5.93-3.33 5.93-2.94 2.53-5.43 1.16c0 0-3.26 1.6-4.12 4.39s-5.91-2.25-10.46-1.48c0 0-3.07-2.88-2.85-9.86a24.3 24.3 0 0 1 2.19-8.76 11.9 11.9 0 0 1 6.53-6.48c5.24-2.34 14.35-.58 15.32 2.91"
                    className="animable"
                    transform-origin="164.748px 216.692px"
                ></path>
                <path
                    id="elhm8ozj2wy2h"
                    fill="#E4897B"
                    d="M167.39 223.62a4.8 4.8 0 0 0 .9 4c1.11 1.21 2.89-.33 3.62-2.45.62-1.89.84-4.85-.79-5.18s-3.38 1.59-3.73 3.63"
                    className="animable"
                    transform-origin="169.824px 223.999px"
                ></path>
                <path
                    id="elaaupsoprxx"
                    fill="#FF97D2"
                    d="M159.71 237.7a20.36 20.36 0 0 0-10.47-4.88 7.64 7.64 0 0 0-8.08 4.88l17.94 3.63Z"
                    className="animable"
                    transform-origin="150.435px 237.046px"
                ></path>
                <path
                    id="elrs1kb8kvzzj"
                    fill="#E4897B"
                    d="m156.66 275.56 7.31 1.09a28.5 28.5 0 0 1 5.1-1.09 33.5 33.5 0 0 1 5.65 0S178 276.8 178 280c0 0-7.72 2.07-10.68.83l-10.66-.83Z"
                    className="animable"
                    transform-origin="167.33px 278.333px"
                ></path>
                <g id="el1zkyitlweq3">
                    <path
                        id="eljbffqlzb9h"
                        d="m156.66 275.56 7.31 1.09a28.5 28.5 0 0 1 5.1-1.09 33.5 33.5 0 0 1 5.65 0S178 276.8 178 280c0 0-7.72 2.07-10.68.83l-10.66-.83Z"
                        className="animable"
                        opacity="0.2"
                        style={{ isolation: "isolate" }}
                        transform-origin="167.33px 278.333px"
                    ></path>
                </g>
                <path
                    id="elkrysfmcqzzo"
                    fill="#FF97D2"
                    d="M168.54 240q-2.23 6.24-4 12c-.76 2.38-1.45 4.71-2.08 7-.54 1.89-1 3.72-1.49 5.5a257.03 257.03 0 0 0-3.46 15.05 166 166 0 0 0-2.7 17.63l-41-5.13c1.42-7.05 2.53-13.2 4.08-19.84.85-3.64 1.83-7.42 3.08-11.57.88-3 1.9-6.15 3.12-9.59 4.11-11.81 7.91-15.08 7.91-15.08 15.74-2.59 36.54 4.03 36.54 4.03"
                    className="animable"
                    transform-origin="141.175px 266.275px"
                ></path>
                <path
                    id="el3cftjalm25v"
                    fill="#E4897B"
                    d="m182.18 276.32 7.31 1.1a28 28 0 0 1 5.1-1.1 35 35 0 0 1 5.65 0s3.31 1.24 3.31 4.41c0 0-7.72 2.07-10.69.83l-10.68-.83Z"
                    className="animable"
                    transform-origin="192.865px 279.08px"
                ></path>
                <path
                    id="eli94vye74m0a"
                    fill="#FF97D2"
                    d="m134.9 400.76 16.6 1.1 2.44-7.17-18.29-.86z"
                    className="animable"
                    transform-origin="144.42px 397.845px"
                ></path>
                <g id="elzz4yf33l38">
                    <path
                        id="elmfj2yh33u"
                        fill="#FFF"
                        d="m134.9 400.76 16.6 1.1 2.44-7.17-18.29-.86z"
                        className="animable"
                        opacity="0.2"
                        transform-origin="144.42px 397.845px"
                    ></path>
                </g>
                <path
                    id="el2qf6ciyf91s"
                    fill="#FF97D2"
                    d="m179.56 400.76 16.6 1.1 2.44-7.17-18.29-.86z"
                    className="animable"
                    transform-origin="189.08px 397.845px"
                ></path>
                <g id="elqhb65bvfn4n">
                    <path
                        id="elwp7qyd5z07p"
                        fill="#FFF"
                        d="m179.56 400.76 16.6 1.1 2.44-7.17-18.29-.86z"
                        className="animable"
                        opacity="0.2"
                        transform-origin="189.08px 397.845px"
                    ></path>
                </g>
                <path
                    id="elhydoedjnl44"
                    d="m113.68 292.58 18.49 2.43.6-2.73-18.52-2.69z"
                    className="animable"
                    transform-origin="123.225px 292.3px"
                ></path>
                <path
                    id="ell53jjybf5yr"
                    d="m134.31 292.3-.23 2.71 17.09 2.35v-2.68z"
                    className="animable"
                    transform-origin="142.625px 294.83px"
                ></path>
                <path
                    id="elb9b9vmf2yxs"
                    d="M152.23 294.83v2.53l2.48.33v-2.45z"
                    className="animable"
                    transform-origin="153.47px 296.26px"
                ></path>
                <g id="el7ceesaai3ho">
                    <path
                        id="eljzbt7yctn6f"
                        d="M164.53 252c-.76 2.38-1.45 4.71-2.08 7-.54 1.89-1 3.72-1.49 5.5-1.28-7 1-15.37 1-15.37Z"
                        className="animable"
                        opacity="0.2"
                        style={{ isolation: "isolate" }}
                        transform-origin="162.55px 256.815px"
                    ></path>
                </g>
                <path
                    id="el74fhlg9flwy"
                    fill="#E4897B"
                    d="M167.3 242.36c3.34.67 5.07 23.87 5.81 26.94.65 2.68 16.38 8.12 16.38 8.12v3.77s-17.4-1.19-21.49-2.87-6.56-24.59-6.56-24.59Z"
                    className="animable"
                    transform-origin="175.465px 261.775px"
                ></path>
                <g id="elgsoio9r53m">
                    <g
                        id="elpersv0wck2d"
                        className="animable"
                        opacity="0.2"
                        style={{ isolation: "isolate" }}
                    >
                        <path
                            id="elni5mc0jymwo"
                            fill="#FFF"
                            d="M168.54 240q-2.23 6.24-4 12c-.76 2.38-1.45 4.71-2.08 7-.54 1.89-1 3.72-1.49 5.5a257.03 257.03 0 0 0-3.46 15.05 166 166 0 0 0-2.7 17.63l-41-5.13c1.42-7.05 2.53-13.2 4.08-19.84.85-3.64 1.83-7.42 3.08-11.57.88-3 1.9-6.15 3.12-9.59 4.11-11.81 7.91-15.08 7.91-15.08 15.74-2.59 36.54 4.03 36.54 4.03"
                            className="animable"
                            transform-origin="141.175px 266.275px"
                        ></path>
                    </g>
                </g>
                <path
                    id="eluyo59ecklyf"
                    fill="#FF97D2"
                    d="M168.54 240c3.06 1 4.57 21 4.57 21L162 262.47l-2.3-8.22s.92-3.88 2.24-7.95c1.92-5.9 6.6-6.3 6.6-6.3"
                    className="animable"
                    transform-origin="166.405px 251.235px"
                ></path>
            </g>
            <path
                id="elsvmi4pjm7gr"
                fill="#263238"
                d="M96.87 415.56a3.52 3.52 0 1 0-3.51 3.52 3.51 3.51 0 0 0 3.51-3.52"
                className="animable"
                transform-origin="93.35px 415.56px"
            ></path>
            <g id="elakp2htja296">
                <path
                    id="el5gosper044b"
                    fill="#FFF"
                    d="M96.87 415.56a3.52 3.52 0 1 0-3.51 3.52 3.51 3.51 0 0 0 3.51-3.52"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="93.35px 415.56px"
                ></path>
            </g>
            <path
                id="elhcyiihzk424"
                fill="#263238"
                d="M181.48 415.56a3.52 3.52 0 1 0-3.52 3.52 3.51 3.51 0 0 0 3.52-3.52"
                className="animable"
                transform-origin="177.96px 415.56px"
            ></path>
            <g id="elwf256bcjvng">
                <path
                    id="el8m7kea28siu"
                    fill="#FFF"
                    d="M181.48 415.56a3.52 3.52 0 1 0-3.52 3.52 3.51 3.51 0 0 0 3.52-3.52"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="177.96px 415.56px"
                ></path>
            </g>
            <g id="el6n34b2suhu4">
                <path
                    id="elmrn77ho4lw"
                    fill="#FFF"
                    d="M95.11 415.56a1.76 1.76 0 1 0-1.75 1.76 1.75 1.75 0 0 0 1.75-1.76"
                    className="animable"
                    opacity="0.2"
                    transform-origin="93.35px 415.56px"
                ></path>
            </g>
            <g id="elbp7ti03qfk7">
                <circle
                    id="elhb6ii4rlgks"
                    cx="177.96"
                    cy="415.56"
                    r="1.76"
                    fill="#FFF"
                    className="animable"
                    opacity="0.2"
                    transform-origin="177.96px 415.56px"
                ></circle>
            </g>
            <path
                id="elrl7gkojgxa"
                fill="#263238"
                d="M138.57 400.14v-37.81h-5.82v37.81c-22.64.58-36.4 8.5-39.16 10.23a1.11 1.11 0 0 0-.51.94v3.14a1.11 1.11 0 0 0 1.11 1.11 1.11 1.11 0 0 0 1-.56l1.34-2.36a127.5 127.5 0 0 1 36.25-6v6.22a1.44 1.44 0 0 0 1.44 1.43h2.94a1.44 1.44 0 0 0 1.44-1.43v-6.22a127.5 127.5 0 0 1 36.25 6l1.34 2.36a1.11 1.11 0 0 0 1 .56 1.11 1.11 0 0 0 1.11-1.11v-3.14a1.11 1.11 0 0 0-.51-.94c-2.79-1.73-16.58-9.65-39.22-10.23"
                className="animable"
                transform-origin="135.69px 388.945px"
            ></path>
            <g id="elqid396sq0h">
                <path
                    id="el122hm93jy7lk"
                    d="M138.57 400.14v-37.81h-5.82v37.81c-22.64.58-36.4 8.5-39.16 10.23a1.11 1.11 0 0 0-.51.94v3.14a1.11 1.11 0 0 0 1.11 1.11 1.11 1.11 0 0 0 1-.56l1.34-2.36a127.5 127.5 0 0 1 36.25-6v6.22a1.44 1.44 0 0 0 1.44 1.43h2.94a1.44 1.44 0 0 0 1.44-1.43v-6.22a127.5 127.5 0 0 1 36.25 6l1.34 2.36a1.11 1.11 0 0 0 1 .56 1.11 1.11 0 0 0 1.11-1.11v-3.14a1.11 1.11 0 0 0-.51-.94c-2.79-1.73-16.58-9.65-39.22-10.23"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="135.69px 388.945px"
                ></path>
            </g>
            <rect
                id="ele4b0tk6iqr"
                width="3.82"
                height="7.03"
                x="133.75"
                y="412.05"
                fill="#263238"
                className="animable"
                rx="0.77"
                transform-origin="135.66px 415.565px"
            ></rect>
            <g id="ele8s7wczzem6">
                <rect
                    id="elz59gdvorht9"
                    width="3.82"
                    height="7.03"
                    x="133.75"
                    y="412.05"
                    fill="#FFF"
                    className="animable"
                    opacity="0.2"
                    rx="0.77"
                    style={{ isolation: "isolate" }}
                    transform-origin="135.66px 415.565px"
                ></rect>
            </g>
            <path
                id="elexke1fuz2mk"
                fill="#FF97D2"
                d="M97.55 325.11h76.23a7.91 7.91 0 0 1 7.91 7.91v4.78H89.63V333a7.91 7.91 0 0 1 7.92-7.89"
                className="animable"
                transform-origin="135.66px 331.455px"
            ></path>
            <path
                id="elqwaq4dz6xvp"
                fill="#263238"
                d="M122.46 293.69h50.68a4 4 0 0 1 4 5L168 337.81h-2.09l7.72-34.32a4.05 4.05 0 0 0-4-4.94H123.5Z"
                className="animable"
                transform-origin="149.864px 315.749px"
            ></path>
            <path
                id="el80dm1vyuia2"
                fill="#263238"
                d="M141.64 339.18v33.08a1.93 1.93 0 0 1-1.92 1.92h-8.11a1.91 1.91 0 0 1-1.92-1.92v-33.08Z"
                className="animable"
                transform-origin="135.665px 356.68px"
            ></path>
            <g id="el3mi6myyreg7">
                <path
                    id="el9qmfw0a4rr"
                    d="M129.69 339.18h11.96v13.74h-11.96z"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="135.67px 346.05px"
                ></path>
            </g>
            <path
                id="elb99h9sd98uv"
                fill="#263238"
                d="M184.2 335.77v4a2 2 0 0 1-2 2h-93a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h93a2 2 0 0 1 2 2"
                className="animable"
                transform-origin="135.7px 337.77px"
            ></path>
            <path
                id="el61wzinn3a8g"
                fill="#263238"
                d="M141.4 337.81H87.12s-17.24-28.68-17.24-76.07v-17.41a13 13 0 0 1 13-13h23a12.94 12.94 0 0 1 13 12.59c.59 24.46 4.19 77.34 22.52 93.89"
                className="animable"
                transform-origin="105.64px 284.57px"
            ></path>
            <g id="elq7ugdbxk849">
                <path
                    id="el5gleewrvnbt"
                    fill="#FFF"
                    d="M129.46 337.81H89.58a4.13 4.13 0 0 1-3.67-2.22c-3.92-7.57-16-34.15-16-73.85v-17.41a13 13 0 0 1 13-13h19.89a13 13 0 0 1 13 12.59c.6 21.81 3.53 66.34 17.22 87.39a4.14 4.14 0 0 1-3.56 6.5"
                    className="animable"
                    opacity="0.2"
                    transform-origin="101.835px 284.572px"
                ></path>
            </g>
            <g id="el4cm60lqdwd5">
                <path
                    id="el5pnza7eqn4c"
                    d="M184.2 335.77v4a2 2 0 0 1-2 2h-41.7a2.74 2.74 0 0 1-2.73-2.73v-2.53a2.73 2.73 0 0 1 2.73-2.73h41.69a2 2 0 0 1 2.01 1.99"
                    className="animable"
                    opacity="0.2"
                    style={{ isolation: "isolate" }}
                    transform-origin="160.985px 337.775px"
                ></path>
            </g>
        </g>
    </svg>
);

export default OnlineTestIllustration
